import { MenuProps } from '@material-ui/core/Menu';
import { OutlinedInputProps } from '@material-ui/core/OutlinedInput';
import { ENUMS_ERROR_ACC_CODE, ENUM_SCOPE_LABEL } from 'constants/Enums';
import { ReactNode } from 'react';

export const objectToQueryString = (obj: CircaProps) => {
  const params = new URLSearchParams();
  const objKeys = Object.keys(obj);
  objKeys.forEach((key: keyof CircaProps) => {
    if (obj[key]) {
      params.append(key, obj[key]);
    }
  });
  return params.toString();
};

export const onSplitErrorMessage = (errorMessage: string): string => {
  const parts = errorMessage.split('.');
  const formattedMessage = parts.join('.\n');
  return formattedMessage;
};

export const getTimeDifferenceInSeconds = (expiredTime: Date, nowTime: Date) => {
  return Math.round((expiredTime.getTime() - nowTime.getTime()) / 1000);
};

export enum PLACEHOLDERS {
  businessType = 'Hình thức kinh doanh là *',
  businessName = 'Tên hộ kinh doanh/doanh nghiệp *',
  address = 'Địa chỉ cụ thể *',
  phoneNumber = 'Nhập số điện thoại *',
  email = 'Nhập email',
  referrerPhoneOrCode = 'Nhập SĐT người giới thiệu hoặc mã',
  taxCode = 'Mã số thuế/Căn cước công dân *',
}

export enum BusinessTypeKey {
  DRUGSTORE = 'DRUGSTORE',
  PHARMACY = 'PHARMACY',
  CLINIC = 'CLINIC',
  HOSPITAL = 'HOSPITAL',
  PHARMA_COMPANY = 'PHARMA_COMPANY',
  DENTISTRY = 'DENTISTRY',
  BEAUTY_SALON = 'BEAUTY_SALON',
  HEALTH_CENTER = 'HEALTH_CENTER',
  PATIENT = 'PATIENT',
  MEDICAL_SUPPLY_STORE = 'MEDICAL_SUPPLY_STORE',
  TRADITIONAL_MEDICINE_STORE = 'TRADITIONAL_MEDICINE_STORE',
}

// Channel type constants for lead tracking
export enum ChannelType {
  UTM = 'UTM',
  Organic = 'Organic',
}

export type BusinessTypeLabel =
  | 'Quầy thuốc'
  | 'Nhà thuốc'
  | 'Phòng khám'
  | 'Bệnh viện'
  | 'Công ty dược phẩm'
  | 'Nha khoa'
  | 'Thẩm mỹ viện'
  | 'Trung tâm y tế'
  | 'Dược sĩ'
  | 'Cửa hàng VTYT/TPCN'
  | 'Cơ sở bán lẻ Đông y';

export type BusinessType = { [key in BusinessTypeKey]: BusinessTypeLabel };

export const BUSINESS_TYPE = ENUM_SCOPE_LABEL as BusinessType;

export type RegistrationModalProps = {
  open: boolean;
  onClose: () => void;
  step: number;
  nextStep: () => void;
  prevStep: () => void;
  onUpdateProvinces: (props: AddressType[]) => void;
  onUpdateReferencePhone: (props: string) => void;
};

export type AuthProps = {
  onSetUserProfile: (user: unknown) => void;
  toggleSignUp: () => void;
  onSetShowOcr: () => void;
  login: (info: unknown, rememberMe: unknown, onSuccess?: () => void) => void;
  toggleLogin: () => void;
};

export type CommonSelect = OutlinedInputProps & {
  iconStart?: ReactNode;
  iconEnd?: ReactNode;
  errorMessage?: ReactNode;
};

// eslint-disable-next-line camelcase
export type CircaProps = { name: string; phone_number: string; source_type: string; action: string };

export type FormStateErrorsType = {
  root: {
    serverError: Partial<{
      type: Partial<ErrorKeys>;
    }>;
  };
};

export type AddressType = { label: string; value: string; regionCode: string };

export enum RegisterFormEnum {
  BusinessType = 'businessType',
  BusinessName = 'businessName',
  TaxCode = 'taxCode',
  Address = 'address',
  Province = 'province',
  District = 'district',
  Ward = 'ward',
  PhoneNumber = 'phoneNumber',
  Email = 'email',
  ReferrerPhoneOrCode = 'referrerPhoneOrCode',
  TermsOfServiceAccepted = 'termsOfServiceAccepted',
  Digit1 = 'digit1',
  Digit2 = 'digit2',
  Digit3 = 'digit3',
  Digit4 = 'digit4',
  SecretKey = 'secretKey',
  identityId = 'identityId',
  PartnerName = 'partnerName',
}

export type RegisterFormType = {
  businessType: string;
  businessName: string;
  taxCode: string;
  address: string;
  province: string;
  district: string;
  ward: string;
  phoneNumber: string;
  email: string;
  referrerPhoneOrCode: string;
  leadSource: string;
  otherSourceDetail: string;
  termsOfServiceAccepted: boolean;
  secretKey: string;
  verificationCode: string;
  identityId?: string;
  partnerName?: string;
};

export enum SIGN_IN_STEPS {
  information,
  otp,
}

export enum OTPEnum {
  Digit1 = 'digit1',
  Digit2 = 'digit2',
  Digit3 = 'digit3',
  Digit4 = 'digit4',
}

export enum PhoneNumberErrors {
  PHONE_EXISTED = 1,
  CUSTOMER_EXISTED,
}

export enum ReferrerPhoneOrCodeError {
  FRIEND_NOT_ACTIVE = 1,
  REFER_PHONE_INVALID,
  REFER_CODE_NOT_EXIST,
}

export const OTP_DIGITS: OTPEnum[] = [OTPEnum.Digit1, OTPEnum.Digit2, OTPEnum.Digit3, OTPEnum.Digit4];

export const DEFAULT_VALUE_FORM: RegisterFormType = {
  businessName: '',
  businessType: '',
  taxCode: '',
  address: '',
  district: '',
  phoneNumber: '',
  email: '',
  province: '',
  referrerPhoneOrCode: '',
  leadSource: '',
  otherSourceDetail: '',
  termsOfServiceAccepted: false,
  ward: '',
  verificationCode: '',
  secretKey: '',
};

export const LIST_ERRORS_TYPE: { [key in string]: string } = {
  ...ENUMS_ERROR_ACC_CODE,
  ROOT: 'root.serverError',
  TOO_MANY_VERIFICATION_CODE_REQUESTS: 'TOO_MANY_VERIFICATION_CODE_REQUESTS',
  PHONE_EXISTED: 'PHONE_EXISTED',
  REFER_PHONE_INVALID: 'REFER_PHONE_INVALID',
  REFER_CODE_NOT_EXIST: 'REFER_CODE_NOT_EXIST',
  FRIEND_NOT_ACTIVE: 'FRIEND_NOT_ACTIVE',
};

export enum ErrorKeys {
  NOT_FOUND = 'NOT_FOUND',
  TOO_MANY_OTP_REQUESTS = 'TOO_MANY_OTP_REQUESTS',
  NOT_FOUND_OTP = 'NOT_FOUND_OTP',
  EXPIRED_OTP = 'EXPIRED_OTP',
  EXPIRED_VERIFICATION_CODE = 'EXPIRED_VERIFICATION_CODE',
  INVALID = 'INVALID',
  TOO_MANY_VERIFICATION_CODE_REQUESTS = 'TOO_MANY_VERIFICATION_CODE_REQUESTS',
  USED_OTP = 'USED_OTP',
  INVALID_CUSTOMER_STATUS = 'INVALID_CUSTOMER_STATUS',
  INACTIVE_ACCOUNT = 'INACTIVE_ACCOUNT',
  CUSTOMER_EXISTED = 'CUSTOMER_EXISTED',
  NOT_FOUND_VERIFICATION_CODE = 'NOT_FOUND_VERIFICATION_CODE',
  PHONE_EXISTED = 'PHONE_EXISTED',
  REFER_PHONE_INVALID = 'REFER_PHONE_INVALID',
  REFER_CODE_NOT_EXIST = 'REFER_CODE_NOT_EXIST',
  FRIEND_NOT_ACTIVE = 'FRIEND_NOT_ACTIVE',
}

export const OTP_ERRORS: string[] = ['TOO_MANY_VERIFICATION_CODE_REQUESTS', 'NOT_FOUND_VERIFICATION_CODE'];

export const LIST_ERRORS_CONTENT: { [key in ErrorKeys]: string } = {
  EXPIRED_OTP: 'Mã xác thực đã hết hiệu lực. Vui lòng nhập mã mới',
  TOO_MANY_VERIFICATION_CODE_REQUESTS: 'Bạn đã gửi quá nhiều yêu cầu. Vui lòng thử lại sau 3 phút',
  // FALLBACK: Keep this for backward compatibility when dynamic parsing doesn't match
  // The dynamic parsing in handleErrorInformation handles email vs phone number distinction, but this serves as fallback
  // for cases where the error message doesn't contain "email" or "phone number" keywords
  CUSTOMER_EXISTED: ' Số điện thoại/Email này đã được đăng ký',
  NOT_FOUND_VERIFICATION_CODE: `Mã xác thực không đúng. Vui lòng kiểm tra và nhập lại!`,
  PHONE_EXISTED: ' Số điện thoại này đã được đăng ký!',
  REFER_PHONE_INVALID: 'Mã giới thiệu không hợp lệ',
  REFER_CODE_NOT_EXIST: 'SĐT hoặc mã giới thiệu không hợp lệ',
  FRIEND_NOT_ACTIVE: 'Mã giới thiệu không hợp lệ',
  NOT_FOUND: 'Mã xác thực không đúng. Vui lòng kiểm tra và nhập lại!',
  NOT_FOUND_OTP: 'Mã xác thực không đúng. Vui lòng kiểm tra và nhập lại!',
  EXPIRED_VERIFICATION_CODE: 'Mã xác thực đã hết hiệu lực. Vui lòng nhập mã mới',
  INVALID: 'Bạn đã đăng ký quá nhiều tài khoản. Vui lòng thử lại sau.',
  TOO_MANY_OTP_REQUESTS: 'Bạn đã gửi quá nhiều yêu cầu. Vui lòng thử lại sau 3 phút',
  USED_OTP: 'Mã xác thực không đúng. Vui lòng kiểm tra và nhập lại!',
  INVALID_CUSTOMER_STATUS: 'Tài khoản của bạn đang tạm ngưng hoạt động.',
  INACTIVE_ACCOUNT: 'Tài khoản của bạn đang tạm ngưng hoạt động.',
};

export const DEFAULT_ADDRESS: AddressType = { label: '', value: '', regionCode: '' };

export const SIGN_UP_OTP_LENGTH = 4;

export const LIST_PLACEHOLDER = {
  province: 'Tỉnh/Thành Phố *',
  district: 'Quận/Huyện *',
  ward: 'Phường/Xã *',
};

export const selectMenuProps: Partial<MenuProps> = {
  anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
  transformOrigin: { vertical: 'top', horizontal: 'left' },
  getContentAnchorEl: null,
  PaperProps: {
    style: {
      marginTop: 5,
      marginLeft: 0,
      padding: 20,
      width: 200,
    },
  },
};

export const ADDRESS_SERVICE_PROPS = {
  isAuth: false,
  isBasic: true,
};

export const TIMER_RESEND_OTP = 180;

export const REMOVE_KEY_CODES: { [key in string]: string } = { '8': 'Backspace', '46': 'Delete' };

export type FormDataType = {
  scope: string;
  businessName: string;
  taxCode: string;
  address: string;
  provinceCode: string;
  districtCode: string;
  wardCode: string;
  phone: string;
  email: string;
  referCode: string;
  leadSource: string;
  otherSourceDetail: string;
  registerURL: string;
  isNewFlow: boolean;
  verificationCode: string;
  secretKey: string;
  identityId: string;
  partnerName: string;
} & { verificationCode?: string };

export const mappingRegisterFormValues = (values: Partial<RegisterFormType>) => {
  const {
    verificationCode = '',
    businessType = '',
    businessName = '',
    taxCode = '',
    address = '',
    province = '',
    ward = '',
    phoneNumber = '',
    email = '',
    district = '',
    referrerPhoneOrCode = '',
    leadSource = '',
    otherSourceDetail = '',
    secretKey = '',
    identityId = '',
    partnerName = '',
  } = values;

  const formData: FormDataType = {
    scope: businessType,
    businessName,
    taxCode: taxCode.trim(),
    address,
    provinceCode: province,
    districtCode: district,
    wardCode: ward,
    phone: phoneNumber,
    email: email,
    referCode: referrerPhoneOrCode,
    leadSource: leadSource,
    otherSourceDetail: otherSourceDetail,
    registerURL: typeof window !== 'undefined' ? window.location.href : '',
    isNewFlow: true,
    verificationCode: verificationCode,
    secretKey: secretKey,
    identityId: identityId,
    partnerName: partnerName,
  };

  return formData;
};

export const REFER_CODE_KIOTVIET = 'KIOTVIET';
export const PARTNER_NAME_KIOTVIET = 'kiotviet';

